'use strict'

const { combineReducers, createStore } = require('redux')
const splitTestData = require('./splitTest')

const mainStore = combineReducers({
  splitTestData
})

module.exports = createStore(mainStore, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())



// WEBPACK FOOTER //
// ./shared/stores/index.js